(() => {
  let timer;
  let generation = 0;
  let controller;
  async function refresh() {
    const current = ++generation;
    controller?.abort();
    controller = new AbortController();
    try {
      const url = new URL(window.routes.cart_url, window.location.origin);
      url.searchParams.set('section_id', 'pb-shipping-progress');
      const response = await fetch(url.toString(), { signal: controller.signal, cache: 'no-store' });
      if (!response.ok) throw new Error('Shipping progress refresh failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = html.querySelector('pb-shipping-progress');
      if (current !== generation) return;
      document.querySelectorAll('pb-shipping-progress').forEach((target) => {
        target.innerHTML = source?.innerHTML || '';
      });
    } catch (error) {
      if (error.name === 'AbortError' || current !== generation) return;
      document.querySelectorAll('pb-shipping-progress').forEach((target) => target.replaceChildren());
    }
  }
  function schedule(event) {
    ++generation;
    controller?.abort();
    clearTimeout(timer);
    const sections = event?.cartData?.sections;
    if (sections) {
      for (const markup of Object.values(sections)) {
        if (typeof markup !== 'string') continue;
        const source = new DOMParser().parseFromString(markup, 'text/html').querySelector('pb-shipping-progress');
        if (!source) continue;
        document.querySelectorAll('pb-shipping-progress').forEach((target) => {
          target.innerHTML = source.innerHTML;
        });
        return;
      }
    }
    timer = setTimeout(refresh, 120);
  }
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  document.addEventListener('pb:cart-updated', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule();
  });
})();
